import React from 'react';
import Icon from 'components/common/Icon';

export default ({ title, text, isSuccess }) => {
  const icon = isSuccess ? 'success' : 'failure';
  return (
    <div className="text-center">
      <Icon icon={`form_sent_${icon}`} className="form-result-icon"/>
      <div className="form-result-text">
        <h2 className="mt-45">{title}</h2>
        <p className="font-size-md">{text}</p>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/FormResult.js